import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";

export const bugsnagClient = import.meta.env.VITE_BUGSNAG_API_KEY
  ? Bugsnag.start({
      apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
      appVersion: import.meta.env.VITE_VERSION,
      releaseStage: import.meta.env.VITE_ENVIRONMENT,
      redactedKeys: [/token/i, /password/i, /passphrase/i],
      collectUserIp: false,
      plugins: [new BugsnagPluginReact(React)],
      onError: (event: { errors: Array<{ stacktrace: unknown[] }> }) => {
        // Remove the call to the logger from the stack trace for better error grouping
        event.errors[0].stacktrace = event.errors[0].stacktrace.slice(1);
      },
    })
  : undefined;

export default bugsnagClient;
